export default __webpack_public_path__ + "static/media/sketch.a6af780a.jpg";